import resetPassword from './resetPassword';
import updatePassword from './updatePassword';
import resetPasswordValidateToken from './resetPasswordValidateToken';
import login from './login';
import logout from './logout';
import auth0 from './auth0';
import checkEmail from './checkEmail';
import sendCode from './sendCode';
import linkEmails from './linkEmails';

export default {
  login,
  logout,
  auth0,
  checkEmail,
  sendCode,
  linkEmails,
  resetPassword,
  updatePassword,
  resetPasswordValidateToken,
};
